<template>
  <el-skeleton class="SubWebPage" :loading="fullscreenLoading" animated variant="p">

      <el-card class="box-card">
        <div slot="header" class="clearfix">
          当前时间
        </div>
        <div class="card-body">
          <div class="divNowTime">
            {{nowData.time}}
          </div>
          <div class="divNowWeekNum" v-if="nowData.semester!=null">
            {{nowData.semester}}
            <span class="spNum" v-if="nowData.weekNum!=null">第 <b class="color-danger">{{nowData.weekNum}}</b> 周</span>
          </div>
        </div>
      </el-card>

  </el-skeleton>
</template>

<script>
  export default {
    data() {
      return {
        fullscreenLoading: false,

        nowData: {
          time: timeTransform(new Date(), 'YYYY-MM-DD HH:mm'),
          weekName: null,
          weekNum: null,
          semester: null,
        }
      };
    },
    created() {
      let that = this;

      that.fullscreenLoading=true;
      let currentDate = timeTransform(new Date(), 'YYYY-MM-DD');
      ajaxGet(that, '/api/admin/semester', null, function(resSemester) {
        that.fullscreenLoading=false;
        if (!regNullArray(resSemester)) {
          let tpSemester = resSemester.find(item => item.isCurrent == true);
          if (!regNull(tpSemester)) {
            that.nowData.semester = tpSemester.name;
            ajaxGet(that, '/api/admin/semesterday/search', {
              SemesterId: tpSemester.semesterId
            }, function(resWeek) {
              let nowTime = timeTransform(new Date(), 'YYYY-MM-DD');
              let tpWeek = resWeek.find(item => timeTransform(item.day, 'YYYY-MM-DD') == nowTime);
              if (!regNull(tpWeek)) {
                that.nowData.weekNum = tpWeek.weekIndex;
              }
            });
          }
        }
      });


      this.timer = setInterval(() => {
        that.nowData.time = timeTransform(new Date(), 'YYYY-MM-DD HH:mm');
      }, 60000);



    },
    methods: {



    },
  };
</script>

<style scoped="scoped">
  .divNowTime {
    text-align: center;
    width: 100%;
    font-size: 62px;
    font-family: 'OswaldLight';
    letter-spacing: 2px;
    color: #2979ff;
    padding-top: 50px;

  }

  .divNowWeekNum {
    padding-top: 30px;
    font-size: 24px;
    text-align: center;
    width: 100%;
    padding-bottom: 50px;
  }

</style>
